import React from 'react';
import Theme from '../../../theme';
import StarIconEmpty from '../../../assets/images/star-icon-empty.svg'
import StarIconOneQuarter from '../../../assets/images/star-icon-one-quarters.svg'
import StarIconHalf from '../../../assets/images/star-icon-half.svg'
import StarThreeQuarters from '../../../assets/images/star-icon-three-quarters.svg'
import StarIconFull from '../../../assets/images/star-icon-full.svg'

export const RatingStarIcon = ({
  width,
  height,
  style,
  type, 
}) => {
  switch (type) {
    case 'Filled':
      return <StarIconFull height={height} width={width} color={Theme.GREY} colorSecondary={Theme.GREY_DARK} />
    case 'ThreeQuarters':
      return <StarThreeQuarters height={height} width={width} color={Theme.GREY} colorSecondary={Theme.GREY_DARK} />
    case 'Half':
      return <StarIconHalf height={height} width={width} color={Theme.GREY} colorSecondary={Theme.GREY_DARK} />
    case 'Quarter':
      return <StarIconOneQuarter height={height} width={width} color={Theme.GREY} colorSecondary={Theme.GREY_DARK} />
    default:
      return <StarIconEmpty height={height} width={width} color={Theme.GREY} colorSecondary={Theme.GREY_DARK} />
  }
}